// extracted by mini-css-extract-plugin
export default {"signup_with_provider":"provider-button_signup_with_provider__9YbXq","providerIcon":"provider-button_providerIcon__v3hHC","chevronRightIcon":"provider-button_chevronRightIcon__9iM61"};